import { type ReactNode } from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  icon?: ReactNode
  iconPosition?: 'left' | 'right'
  variant?: 'primary' | 'secondary' | 'outline' | 'transparent'
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
  className?: string
  loading?: boolean
}

const Button = ({
  children,
  onClick,
  icon,
  iconPosition = 'left',
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  loading = false
}: ButtonProps) => {
  const baseStyles = 'rounded-[10px] font-[700] text-[16px] flex items-center justify-center gap-2 transition-colors min-w-fit'
  
  const variantStyles = {
    primary: 'bg-[#030208] text-[#FBFBFE] hover:bg-gray-800',
    secondary: 'bg-muted text-foreground hover:bg-gray-300',
    outline: 'border-[1px] border-[#B8B5B6] text-foreground hover:bg-[#28282A] hover:text-white',
    transparent: 'text-foreground hover:bg-[#28282A] hover:text-gray-300'

  }
  
  const sizeStyles = {
    sm: 'px-3 py-2 text-[14px] h-[30px] ',
    md: 'px-4 py-2 text-[16px] h-[46px]',
    lg: 'px-6 py-3 text-lg h-[52px]'
  }

  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'

  return (
    <button
      onClick={!disabled ? onClick : undefined}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${className}`}
      disabled={disabled}
    >
      {icon && iconPosition === 'left' && icon}
      {loading ? (
        <div className="flex items-center justify-center space-x-2">
          {/* Spinning circle to show something is happening */}
          <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
          <span>Loading...</span>
        </div>
      ) : (
        children
      )}
      {icon && iconPosition === 'right' && icon}
    </button>
  )
}

export default Button